import { Box, Text } from "native-base";
import React from "react";
import { FlatList } from "react-native";

import EmptyList from "@/components/molecules/EmptyList";
import MobileHeader from "@/components/molecules/MobileHeader";
import SimpleWebHeader from "@/components/molecules/SimpleWebHeader";
import Container from "@/components/organisms/Container";

import NotificationItem from "./components/NotificationItem";
import NotificationsLoading from "./components/NotificationsLoading";
import { NotificationListScreenProps } from "./types";

const NotificationListWeb = ({
  notifications,
  isLoading,
  onBack,
  onPressDelete,
  onSelect,
}: NotificationListScreenProps) => {
  return (
    <Container pb="32" Header={<SimpleWebHeader />}>
      <Box py="4">
        <MobileHeader title="Notificações" onBackPress={onBack} showLogo={false} />
      </Box>
      {isLoading ? (
        <NotificationsLoading />
      ) : (
        <FlatList
          data={notifications || []}
          nestedScrollEnabled
          keyExtractor={(item, index) => (item ? item._id : String(index))}
          showsVerticalScrollIndicator={false}
          renderItem={({ item }) => (
            <NotificationItem
              notification={item}
              onPressDelete={onPressDelete}
              onSelect={onSelect}
            />
          )}
          ListEmptyComponent={
            <Box w="1/2" alignSelf="center" py="8">
              <EmptyList />
              <Text py="6" textAlign="center" fontSize="lg">
                Você receberá notificações sobre o status da sua compra ou sobre as nossas novidades
                e promoções. Fique de olho!
              </Text>
            </Box>
          }
        />
      )}
    </Container>
  );
};

export default NotificationListWeb;
